var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-bq-cms-wrap cms-wrap"},[(_vm.$route.params.key === 'home' || _vm.$route.params.key === 'home-mb')?[_c('QuickRegister')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }